import React from 'react';
import '../styles/AboutUs.css';
import QuickLink from '../../../SharedComponents/QuickLink';
import OptimisedImage from '../../../SharedComponents/OptimisedImage';

class AboutUs extends React.Component {

  render() {
    return(
      <div id="aboutus">
        <section id="aboutus-funding">
          <h1>Funding</h1>
          <div className="content">
            <div className="asidecontent">
              <OptimisedImage image={require('../images/__assets__/BBSRC-logo.jpg')} alt="Biotechnology and Biological Sciences Research Council Logo"/>
              <OptimisedImage image={require('../images/__assets__/EPSRC-logo.jpg')} alt="Engineering and Physical Sciences Research Council Logo"/>
            </div>
            <div className="maincontent">
              <p>
                The Hub is funded jointly by the Engineering and Physical Sciences 
                Research Council (EPSRC) and the Biotechnology and Biological Sciences
                Research Council (BBSRC) and is part of the wider Supergen Programme.
              </p>
              <p>
                The authors thank EPSRC, BBSRC and the Supergen Bioenergy Hub 
                (EP/S000771/1) who funded and supported this research.
              </p>
            </div>
          </div>
        </section>

        <hr className="hr"/>

        <section id="aboutus-development">
          <h1>Development</h1>
          <div className="content">
            <div className="asidecontent">
              <OptimisedImage image={require('../images/__assets__/UoMLogo.png')} alt="Biotechnology and Biological Sciences Research Council Logo"/>
              <OptimisedImage image={require('../images/__assets__/iocLogo.png')} alt="Engineering and Physical Sciences Research Council Logo"/>
            </div>
            <div className="maincontent">
              <p>
                Developed by Imago Software, the University of Manchester Student Software Company. Imago Software is funded by a grant
                from the Office for Students and the University of Manchester, and is a member of the Institute of
                Coding's network of student enterprises in the UK.
              </p>
              <p>
                Contact Imago Software at <a href="mailto:uomssc@gmail.com">uomssc@gmail.com</a>.
              </p>
              <QuickLink type="external" text="University of Manchester" link="https://www.manchester.ac.uk/"/>
              <QuickLink type="external" text="Institute of Coding" link="https://instituteofcoding.org/"/>
              <QuickLink type="external" text="Office for Students" link="https://www.officeforstudents.org.uk/"/>
            </div>
          </div>
        </section>

        <hr className="hr"/>

        <section id="aboutus-copyright">
          <h1>Copyright</h1>
          <p>
            &copy; Supergen Bioenergy Hub Copyright 2018 - 2020
          </p>
          <p>
            The text of this document (this excludes, where present, all 
            departmental or agency logos) may be reproduced free of charge in any 
            format or medium provided that it is reproduced accurately and not in 
            a misleading context. The material must be acknowledged as Supergen 
            Bioenergy Hub copyright and the document title specified.
          </p>
          <p>
            Permission from copyright holders must be sought before any graphs or 
            illustrations are reproduced. You can download this publication from <a href="https://www.supergen-bioenergy.net/outputs">www.supergen-bioenergy.net/outputs</a>.
          </p>
          <p>
            All enquiries related to this publication should be sent to <a href="mailto:supergen-bioenergy@aston.ac.uk">supergen-bioenergy@aston.ac.uk</a>.
          </p>
        </section>
      </div>
    );
  }
}

export default AboutUs;